export default __webpack_public_path__ + "static/media/Sucursal.e4e4a506.png";